import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ 1. IMPORT KIYA

// --- AAPKA CONFIG CODE ---
// (Yahan apna purana firebaseConfig wala code rehne dena)
const firebaseConfig = {
  apiKey: "AIzaSyB4b47hPA2wGYWUIhkajcnWSUb8w_gQduU",
  authDomain: "labourhiringindia.firebaseapp.com",
  databaseURL: "https://labourhiringindia-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "labourhiringindia",
  storageBucket: "labourhiringindia.firebasestorage.app",
  messagingSenderId: "1057256057838",
  appId: "1:1057256057838:web:7a3b1a9e7a820a22dd3cff",
  measurementId: "G-46XRJ8RJCM"
};

// --- INITIALIZE ---
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // ✅ 2. START KIYA

// --- EXPORT (SABSE ZAROORI LINE) ---
export { auth, db, storage }; // ✅ 3. EXPORT KIYA